import { createAction, props } from '@ngrx/store';
import { ResourceUri } from '@ngxp/rest';
import { VerfahrenResource } from '@schir-int-client/verfahren-shared';
import { VorgangListResource, VorgangResource, VorgangStatus, VorgangTyp } from './vorgang.model';
import { Moment } from 'moment';

const PREFIX = '[Vorgang] ';

export const createVorgangInVerfahrenAction = createAction(
	PREFIX + 'Create Vorgang In Verfahren',
	props<{
		vorgangTyp: VorgangTyp;
		uri: ResourceUri;
	}>()
);

export const createVorgangInVerfahrenSuccessAction = createAction(
	PREFIX + 'Create Vorgang In Verfahren Success',
	props<{
		vorgaenge: VorgangListResource;
		verfahren: VerfahrenResource;
	}>()
);

export const loadVorgangAction = createAction(
	PREFIX + 'Load Vorgang',
	props<{
		vorgangUri: string;
	}>()
);

export const loadVorgangSuccessAction = createAction(
	PREFIX + 'Load Vorgang Success',
	props<{
		vorgang: VorgangResource;
	}>()
);

export const selectVorgangAction = createAction(
	PREFIX + 'Select Vorgang',
	props<{
		vorgang: VorgangResource;
	}>()
);

export const loadVorgaengeByVerfahrenAction = createAction(
	PREFIX + 'Load Vorgaenge By Verfahren',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadVorgaengeByVerfahrenSuccessAction = createAction(
	PREFIX + 'Load Vorgaenge By Verfahren Success',
	props<{
		vorgaenge: VorgangListResource;
		verfahren: VerfahrenResource;
	}>()
);

export const loadVorgaengeRechtspflegeAction = createAction(PREFIX + 'Load Vorgaenge Rechtspflege');

export const loadVorgaengeRechtspflegeSuccessAction = createAction(
	PREFIX + 'Load Vorgaenge Rechtspflege Success',
	props<{
		vorgaenge: VorgangResource[];
	}>()
);

export const loadVorgaengeInRuecklaufAction = createAction(PREFIX + 'Load Vorgaenge In Ruecklauf');

export const loadVorgaengeInRuecklaufSuccessAction = createAction(
	PREFIX + 'Load Vorgaenge In Ruecklauf Success',
	props<{
		vorgaenge: VorgangListResource;
	}>()
);

export const updateVorgangNotizAction = createAction(
	PREFIX + 'Update Vorgang Notiz',
	props<{
		notiz: string;
		vorgang: VorgangResource;
	}>()
);

export const updateVorgangNotizSuccessAction = createAction(
	PREFIX + 'Update Vorgang Notiz Success',
	props<{
		vorgang: VorgangResource;
	}>()
);

export const setVorgangStatusAction = createAction(
	PREFIX + 'Mark Vorgang',
	props<{
		vorgang: VorgangResource;
		status: Exclude<VorgangStatus, VorgangStatus.NEU>;
		wiedervorlageDatum?: Moment;
	}>()
);

export const setVorgangStatusSuccessAction = createAction(
	PREFIX + 'Mark Vorgang Success',
	props<{
		vorgang: VorgangResource;
	}>()
);

export const deleteVorgangAction = createAction(
	PREFIX + 'Delete Vorgang',
	props<{
		vorgang: VorgangResource;
	}>()
);

export const deleteVorgangSuccessAction = createAction(
	PREFIX + 'Delete Vorgang Success',
	props<{
		uri: ResourceUri;
	}>()
);

export const loadVorgaengeInWiedervorlageAction = createAction(
	PREFIX + 'Load Vorgaenge In Wiedervorlage',
	props<{
		von: Moment;
		bis: Moment;
	}>()
);

export const loadVorgaengeInWiedervorlageSuccessAction = createAction(
	PREFIX + 'Load Vorgaenge In Wiedervorlage Success',
	props<{
		wiedervorlagen: VorgangListResource;
	}>()
);

export const loadFristenListeAction = createAction(PREFIX + 'Load Fristen Liste');

export const loadFristenListeSuccessAction = createAction(
	PREFIX + 'Load Fristen Liste Success',
	props<{
		fristenListe: VorgangListResource;
	}>()
);

export const updateDatumsBereichAction = createAction(
	PREFIX + 'Update Datums Bereich',
	props<{
		von: Moment;
		bis: Moment;
	}>()
);
